'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslationMessageBundle = exports.getHistoricalData = exports.getUSFundData = exports.getOWCSData = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _cms_utility = require('common-utilities/src/cms_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundsService = {
  getOWCSData: function getOWCSData(userLoggedIn, cusip, country, language, role, owcsDocumentServiceUrl) {
    return _jquery2.default.get(owcsDocumentServiceUrl + '?cusip=' + cusip + '&country=' + country + '&language=' + language + '&role=' + role + '&userLoggedIn=' + userLoggedIn + '&version=8.8_1746361865').then(function (e) {
      return e;
    });
  },
  getDocumentData: function getDocumentData(country, accessCode, documentServiceUrl) {
    if ((0, _cms_utility.isChinaMobile)(country)) {
      return _jquery2.default.get(documentServiceUrl + '&ac=' + accessCode).then(function (e) {
        return e;
      }, function () {
        return {};
      });
    } else {
      return _jquery2.default.when();
    }
  },
  getUSFundData: function getUSFundData(userLoggedIn, cusip, country, role, language, productDataServiceUrl) {
    /* eslint-disable new-cap */
    if (role === _constants2.default.getOrionRole()) {
      return _jquery2.default.get(productDataServiceUrl + '?cusip=' + cusip + '&country=' + country + '&role=' + role + '&userLoggedIn=' + userLoggedIn + '&version=8.8_1746361865');
    } else {
      return _jquery2.default.get(productDataServiceUrl + '?cusip=' + cusip + '&country=' + country + '&role=' + role + '&language=' + language + '&userLoggedIn=' + userLoggedIn + '&version=8.8_1746361865');
    }
  },
  getICFundData: function getICFundData(figiIDs, country, language, role, currencyCode, icServiceUrl, growthOf10KFromDate) {
    /* eslint-disable new-cap */
    if ((0, _functional_utility.isNilOrEmpty)(figiIDs)) {
      return [];
    }

    var figiID = figiIDs.join('$');
    if (!(0, _ramda.isNil)(growthOf10KFromDate)) {
      return _jquery2.default.get(icServiceUrl + '?country=' + country + '&role=' + role + '&currency=' + currencyCode + '&language=' + language + '&figiIds=' + figiID + '&growthOf10KFromDate=' + growthOf10KFromDate);
    }
    return _jquery2.default.get(icServiceUrl + '?country=' + country + '&role=' + role + '&currency=' + currencyCode + '&language=' + language + '&figiIds=' + figiID);
  },
  getICAutocompleteData: function getICAutocompleteData(query, icAutocompleteUrl) {
    /* eslint-disable new-cap */
    return _jquery2.default.get(icAutocompleteUrl + '?query=' + query);
  },
  getHistoricalData: function getHistoricalData(userLoggedIn, cusip, country, role, language, historicalServiceUrl) {
    /* eslint-disable new-cap */
    if (role === _constants2.default.getOrionRole()) {
      return _jquery2.default.get(historicalServiceUrl + '?cusip=' + cusip + '&country=' + country + '&role=' + role + '&userLoggedIn=' + userLoggedIn + '&version=8.8_1746361865');
    } else {
      return _jquery2.default.get(historicalServiceUrl + '?cusip=' + cusip + '&country=' + country + '&role=' + role + '&userLoggedIn=' + userLoggedIn + '&language=' + language + '&version=8.8_1746361865');
    }
  },
  getTranslationMessageBundle: function getTranslationMessageBundle(country, role, language, messageBundleServiceUrl) {
    /* eslint-disable new-cap */
    return _jquery2.default.get(messageBundleServiceUrl + '?country=' + country + '&language=' + language + '&version=8.8_1746361865');
  }
};

exports.default = FundsService;
var getOWCSData = FundsService.getOWCSData,
    getUSFundData = FundsService.getUSFundData,
    getHistoricalData = FundsService.getHistoricalData,
    getTranslationMessageBundle = FundsService.getTranslationMessageBundle;
exports.getOWCSData = getOWCSData;
exports.getUSFundData = getUSFundData;
exports.getHistoricalData = getHistoricalData;
exports.getTranslationMessageBundle = getTranslationMessageBundle;